// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    StripeCustomer,
    StripeCustomerFromJSON,
    StripeCustomerToJSON,
    SubscriptionInvoice,
    SubscriptionInvoiceFromJSON,
    SubscriptionInvoiceToJSON,
    SubscriptionItems,
    SubscriptionItemsFromJSON,
    SubscriptionItemsToJSON,
    SubscriptionPaymentMethod,
    SubscriptionPaymentMethodFromJSON,
    SubscriptionPaymentMethodToJSON,
    SubscriptionPlan,
    SubscriptionPlanFromJSON,
    SubscriptionPlanToJSON,
    SubscriptionTaxRate,
    SubscriptionTaxRateFromJSON,
    SubscriptionTaxRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    collectionMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    currentPeriodEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    currentPeriodStart?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Subscription
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    daysUntilDue?: number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    discount?: number;
    /**
     * 
     * @type {SubscriptionPlan}
     * @memberof Subscription
     */
    plan: SubscriptionPlan;
    /**
     * 
     * @type {StripeCustomer}
     * @memberof Subscription
     */
    customer?: StripeCustomer;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    taxPercent?: number;
    /**
     * 
     * @type {SubscriptionPaymentMethod}
     * @memberof Subscription
     */
    defaultPaymentMethod?: SubscriptionPaymentMethod;
    /**
     * 
     * @type {SubscriptionInvoice}
     * @memberof Subscription
     */
    latestInvoice?: SubscriptionInvoice;
    /**
     * 
     * @type {SubscriptionItems}
     * @memberof Subscription
     */
    items?: SubscriptionItems;
    /**
     * 
     * @type {Array<SubscriptionTaxRate>}
     * @memberof Subscription
     */
    defaultTaxRates?: Array<SubscriptionTaxRate>;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return {
        'id': json['id'],
        'collectionMethod': !exists(json, 'collection_method') ? undefined : json['collection_method'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'currentPeriodEnd': !exists(json, 'current_period_end') ? undefined : json['current_period_end'],
        'currentPeriodStart': !exists(json, 'current_period_start') ? undefined : json['current_period_start'],
        'cancelAtPeriodEnd': !exists(json, 'cancel_at_period_end') ? undefined : json['cancel_at_period_end'],
        'daysUntilDue': !exists(json, 'days_until_due') ? undefined : json['days_until_due'],
        'discount': !exists(json, 'discount') ? undefined : json['discount'],
        'plan': SubscriptionPlanFromJSON(json['plan']),
        'customer': !exists(json, 'customer') ? undefined : StripeCustomerFromJSON(json['customer']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'taxPercent': !exists(json, 'tax_percent') ? undefined : json['tax_percent'],
        'defaultPaymentMethod': !exists(json, 'default_payment_method') ? undefined : SubscriptionPaymentMethodFromJSON(json['default_payment_method']),
        'latestInvoice': !exists(json, 'latest_invoice') ? undefined : SubscriptionInvoiceFromJSON(json['latest_invoice']),
        'items': !exists(json, 'items') ? undefined : SubscriptionItemsFromJSON(json['items']),
        'defaultTaxRates': !exists(json, 'default_tax_rates') ? undefined : (json['default_tax_rates'] as Array<any>).map(SubscriptionTaxRateFromJSON),
    };
}

export function SubscriptionToJSON(value?: Subscription): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'collection_method': value.collectionMethod,
        'created': value.created,
        'current_period_end': value.currentPeriodEnd,
        'current_period_start': value.currentPeriodStart,
        'cancel_at_period_end': value.cancelAtPeriodEnd,
        'days_until_due': value.daysUntilDue,
        'discount': value.discount,
        'plan': SubscriptionPlanToJSON(value.plan),
        'customer': StripeCustomerToJSON(value.customer),
        'status': value.status,
        'tax_percent': value.taxPercent,
        'default_payment_method': SubscriptionPaymentMethodToJSON(value.defaultPaymentMethod),
        'latest_invoice': SubscriptionInvoiceToJSON(value.latestInvoice),
        'items': SubscriptionItemsToJSON(value.items),
        'default_tax_rates': value.defaultTaxRates === undefined ? undefined : (value.defaultTaxRates as Array<any>).map(SubscriptionTaxRateToJSON),
    };
}


